import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Drawer, Form, Input, Select, Spin } from "antd";
import PropTypes from "prop-types";

import { Modals, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import UploadImage from "components/UploadImage";

const Component = ({ data = {}, onUpdate, options: { os, images = [] } }) => {
	const initialState = { users: [] };
	const [state, setState] = useState(initialState);
	const { loading, submitting, visible } = state;
	const { id } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				const action =
					hash === `#${Modals.CREATE}`
						? API.platform.create(values)
						: API.platform.update(id, values);

				action
					.then(() => {
						onUpdate(null, true);
						navigate(-1);
					})
					.catch(() => {
						setState((prevState) => ({
							...prevState,
							submitting: false,
						}));
					});
			});
		}
	};

	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}
			case `#${Modals.EDIT}`: {
				if (id) {
					setState((prevState) => ({
						...prevState,
						visible: true,
						loading: true,
					}));

					API.platform
						.details(id)
						.then(({ data }) => {
							form.setFieldsValue({
								...data,
								coverId: data.cover.id,
							});

							setState((prevState) => ({
								...prevState,
								loading: false,
							}));
						})
						.catch(() => {
							setState((prevState) => ({
								...prevState,
								loading: false,
							}));
						});
				} else {
					navigate(`${pathname}${search}`, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Drawer
			className="sp-form-drawer"
			footer={
				<>
					<Button
						type="primary"
						onClick={handleSubmit}
						loading={submitting}
					>
						{Resources.confirm}
					</Button>
					<Button
						onClick={() => navigate(-1)}
						loading={submitting}
					>
						{Resources.cancel}
					</Button>
				</>
			}
			onClose={() => navigate(-1)}
			title={`${
				hash === `#${Modals.CREATE}` ? Resources.add : Resources.edit
			} ${Resources.platform}`}
			maskClosable={false}
			open={visible}
			width={414}
		>
			<Form
				layout="vertical"
				form={form}
			>
				{loading ? (
					<Spin className="sp-drawer-spin" />
				) : (
					<>
						<Form.Item
							name="title"
							label={Resources.title}
							rules={Rules.required}
						>
							<Input />
						</Form.Item>

						<Form.Item
							name="os"
							label={Resources.os}
							rules={Rules.required}
						>
							<Select options={os} />
						</Form.Item>
						<Form.Item
							name="url"
							label={Resources.link}
							rules={Rules.required}
						>
							<Input />
						</Form.Item>
						<Form.Item
							name="coverId"
							label={Resources.image}
							rules={Rules.required}
						>
							<Select
								options={images}
								optionFilterProp="label"
								showSearch
							/>
						</Form.Item>
					</>
				)}
			</Form>
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
};

export default Component;
